/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'debitnote': {
    width: 11,
    height: 7,
    viewBox: '0 0 11 7',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M1.913 4.393c.8 0 1.45.65 1.45 1.452M8.496 5.817a1.49 1.49 0 0 1 1.532-1.47M8.213 1.228c.12.853.882 1.5 1.836 1.377M3.458 1.216c0 .801-.65 1.45-1.451 1.45M6.098 1.54v1M5.098 4.19c.171.218.462.411.69.454.365.07.71-.134.77-.453.06-.32-.225-.537-.552-.703-.336-.18-.612-.384-.552-.703.06-.32.405-.522.77-.453a.694.694 0 0 1 .52.4M6.07 4.493v1"/><path pid="1" d="M1.493.791h9v5.393h-9z"/></g>'
  }
})
